<div class="scaffold-block-styling" [ngClass]="classes" [style]="calcStyle()|safeStyle">
  <app-rendered [childview]="item.childview || childview" [info]="info" *ngFor="let it of item.content" [paramprefix]="item.paramprefix" [item]="it" [arr]="item.content" [data]="data"></app-rendered>
  <div class="clearfix"></div>
</div>
